<template>
    <div class="projects">
        <div class="container">
            <h2>{{title}}</h2>
            <div class="row mt-5">
                <div v-for="project in projects" :key="project" class="col-12 col-md-6">
                    <img :src="project.porto" alt="" class="w-100 mt-4">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                title : 'Here are some of the projects we have worked on.',
                projects :[
                    {
                       porto : require('../assets/img-project/Project 4.jpg') 
                    },
                    {
                       porto : require('../assets/img-project/Project 1.jpg') 
                    },
                    {
                       porto : require('../assets/img-project/Project 2.jpg') 
                    },
                    {
                       porto : require('../assets/img-project/Project 3.jpg') 
                    },
                ]

            }
        }
        // props : {
        //     project:String
        // }
    }
</script>

<style scoped>
    .projects{
        margin: 300px auto;
        color: #ffff;
    }
    .projects h2{
        width: 30rem;
    }
    
    /* Large Desktop */
    @media(min-width: 1200px){

    }
    /* Middle Desktop */
    @media(min-width: 1025px) and (max-width: 1199px){

    }
    /* Desktop */
    @media(min-width: 992px) and (max-width: 1024px){

    }
    /* Tablet */
    @media(min-width: 768px) and (max-width: 991px){

    }
    /* Handphone */
    @media(max-width: 767px){
        .projects h2{
            text-align: center;
            margin: auto;
            width: 100%;
         }
    }
</style>